<template>
  <el-main class="materialwrap">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-if="query.kind == 1">
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/project' }">项目列表</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: `/project/detail?id=${query.cid ? query.cid : query.pid}` }">项目详情</el-breadcrumb-item>
        <el-breadcrumb-item>更新收款</el-breadcrumb-item>
      </el-breadcrumb>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-else>
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/apply' }">收款管理</el-breadcrumb-item>
        <el-breadcrumb-item>更新收款状态</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="base1">
      <h3 class="ntitle">新增发票</h3>
      <ul>
        <li>
          <p>
            <label>项目名称：</label><a>{{ projectArr.contract_name ? projectArr.contract_name : form.projectArr.contract_name
            }}</a>
          </p>
          <p>
            <label>发票类型：</label><a>{{ dd.invoice_type[form.type] }}</a>
          </p>
          <p>
            <label>税率：</label><a>{{ form.tax_rate + '%' }}</a>
          </p>
          <p>
            <label>期望开票时间：</label><a>{{ form.hope_time }}</a>
          </p>
          <p>
            <label>发票备注：</label><a>{{ form.invoice_mark }}</a>
          </p>
          <p>
            <label>备注：</label><a>{{ form.info }}</a>
          </p>
        </li>
        <li>
          <p>
            <label>收款计划名称：</label><a>{{ form.billArr && form.billArr.bill_name }}</a>
          </p>
          <p>
            <label>开票金额：</label><a>{{ form.amount }}</a>
          </p>
          <p>
            <label>税额：</label><a>{{ form.tax }}</a>
          </p>
          <p>
            <label>开票内容：</label><a>{{ dd.category_type[form.category] }}</a>
          </p>
        </li>
      </ul>
    </div>
    <div class="base1">
      <h3 class="ntitle">开票信息</h3>
      <ul>
        <li>
          <p>
            <label>客户公司名称：</label><a>{{ form.client_company }}</a>
          </p>
          <p>
            <label>公司注册地址：</label><a>{{ form.reg_address }}</a>
          </p>
          <p>
            <label>银行名称：</label><a>{{ form.pay_bank }}</a>
          </p>
        </li>
        <li>
          <p>
            <label>统一社会信用代码：</label><a>{{ form.company_id_card }}</a>
          </p>
          <p>
            <label>公司电话：</label><a>{{ form.company_phone }}</a>
          </p>
          <p>
            <label>银行账号：</label><a class="hoverlink" @click="clickCopy(form.pay_bank_account)">{{ form.pay_bank_account
            }}</a>
          </p>
        </li>
      </ul>
    </div>
    <div class="base1">
      <h3 class="ntitle">发票信息</h3>
      <ul v-for="(item, index) in form.invoiceList" :key="index">
        <li>
          <p>
            <label>发票代码：</label><a>{{ item.invoice_code }}</a>
          </p>
          <p>
            <label>金额：</label><a>{{ item.invoice_amount }}</a>
          </p>
          <p>
            <label>发票状态：</label><a>{{ dd.invoice_update[item.status] }}</a>
          </p>
          <p>
            <label>发票附件：</label>
            <template>
              <ul class="bbox">
                <li v-for="(_it, _id) in item.atta_str" :key="_id">
                  <el-col :span="24" v-if="_it.origin_name">
                    <el-col :span="20">
                      <div class="origin-name">{{ _it.origin_name }}</div>
                    </el-col>
                    <el-col :span="4">
                      <el-link type="primary" style="margin-right:5px" :href="_it.httpFile" target="_blank">查看</el-link>
                    </el-col>
                  </el-col>
                  <el-col v-else>
                    暂无发票
                  </el-col>
                </li>
              </ul>
            </template>
          </p>
        </li>
        <li>
          <p>
            <label>发票号码：</label><a>{{ item.invoice_no }}</a>
          </p>
          <p>
            <label>发票日期：</label><a>{{ item.invoice_date }}</a>
          </p>
        </li>
      </ul>
    </div>

    <div class="form myform" v-if="NodeInclude('43')">
      <el-form ref="form" :model="form" label-width="150px" label-position="left">
        <div class="formtitle">收款信息</div>
        <template>
          <ul class="anlist">
            <li v-for="(item, index) in form.receiveList" :key="index">
              <div class="abox">
                <div class="abox-title">第{{ index + 1 }}笔收款</div>
                <el-form-item label="收款金额：" prop="receive_amount">
                  <el-col :span="12">
                    <el-input placeholder="收款金额" maxlength="100" v-model="item.receive_amount"
                      @change="v => numberFn(v, item)" clearable
                      :disabled="((item.id && item.id != '') || (item.receive_id && item.receive_id != 0)) && level != 1" />
                  </el-col>
                </el-form-item>
                <el-form-item label="收款日期：" prop="receive_date">
                  <el-col :span="5">
                    <el-date-picker v-model="item.receive_date" type="datetime" value-format="yyyy-MM-dd"
                      style="width: 100%;"
                      :disabled="((item.id && item.id != '') || (item.receive_id && item.receive_id != 0)) && level != 1">
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </div>
              <template>
                <ul class="anlist">
                  <li v-for="(_it, _id) in item.atta_str" :key="_id">
                    <div class="abox">
                      <el-form-item :label='`收款凭证附件${_id + 1}：`'>
                        <!-- 选择文件 -->
                        <el-col :span="3" v-if="!_it.id && !_it.file_id">
                          <el-upload class="upload-demo" :ref="`upFile${_id}`" action="#" :limit="1"
                            :show-file-list="false" :auto-upload="false"
                            accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="_it.flist"
                            :on-change="(arg) => uploadFile(arg, item.atta_str, `upFile${_id}`, _it, _id)">
                            <el-button size="small" style="width: 80px;">选择文件</el-button>
                          </el-upload>
                        </el-col>
                        <el-col :span="3" v-else>
                          <el-button size="small" style="width: 80px;" disabled>选择文件</el-button>
                        </el-col>
                        <!-- 文件预览及下载 -->
                        <template v-if="_it.origin_name">
                          <el-col :span="10">
                            <el-col :span="18">
                              <div class="origin-name"> {{ _it.origin_name }}</div>
                            </el-col>
                            <el-col :span="4">
                              <el-link type="primary" style="margin-right:5px" :href="_it.httpFile"
                                target="_blank">查看</el-link>
                            </el-col>
                          </el-col>
                        </template>
                      </el-form-item>
                    </div>
                    <el-button class="bbtn" v-if="!_it.id && !_it.file_id" icon="el-icon-minus"
                      @click="removeImage(item.atta_str, _id)" circle></el-button>
                  </li>
                  <el-button type="primary" style="margin: 0 0 15px 150px;" class="addbtn" @click="addImage(item.atta_str)">新增收款凭证</el-button>
                </ul>
              </template>
              <el-button class="abtn" v-if="!((item.id && item.id != '') || (item.receive_id && item.receive_id != 0))" icon="el-icon-minus" @click="removeReceive(form.receiveList, index)" circle></el-button>
            </li>
            <el-button type="primary" style="margin: 0 0 15px -5px;" class="addbtn" @click="addReceive(form.receiveList)">新增收款</el-button>
          </ul>
        </template>
        <el-form-item label="收款状态：" prop="status">
          <el-col :span="2">
            {{ form.status ? dd.is_receive_apply[form.is_receive] : '未收款' }}
          </el-col>
        </el-form-item>

        <el-form-item label="">
          <el-col>
            <el-button @click="resetForm('form')">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">保存</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>
  </el-main>
</template>

<script>
import * as api from '@/api'
import { timeFormat } from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'applydetail',
  data() {
    return {
      nodeLimtList: [],
      level: '',
      billList: [],
      projectArr: {},
      billArr: {
        bill_name: '',
        amount: '',
      },
      projectList: [],
      form: {
        //客户信息
        apply_id: '',
        apply_status: '1', //1是未申请，0已申请 
        project_id: '',
        project_bill_id: '',
        type: '2',
        amount: '',
        tax_rate: '',
        tax: '',
        hope_time: '',
        category: '1',
        invoice_mark: '',
        info: '',
        client_company: '',
        company_id_card: '',
        reg_address: '',
        company_phone: '',
        pay_bank: '',
        pay_bank_account: '',
        receive_date: '',
        option: '',
        receiveList: [
          { receive_amount: '', receive_date: '', atta_str: [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }], }
        ],
        projectArr: {
          contract_name: ''
        },
        billArr: {
          bill_name: '',
        }
      },
      del_receive_list: [],
      del_atta_list: [],
      p: 1,
      type: 0,
    }
  },
  created() {
    // console.log(this.$route)
    this.query = this.$route.query
    this.query.id && this.getDetail(this.query.id)
    this.query.pid && (this.form.project_id = this.query.pid) && this.projectChange(this.query.pid)
    this.query.pid && this.checkUrlFn()
    this.query.pid && this.checkNodeFn('61')
  },
  mounted() {

  },
  watch: {
    ['form.pay_bank_account'](val) {
      if (val != undefined) {
        this.$nextTick(() => {
          this.form.pay_bank_account = val.replace(/\D/g, '').replace(/....(?!$)/g, '$& ');
        });
      }
    },
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    numberFn(v, item) {
      v = v.toString().replace(/,/g, "")
      item.receive_amount = v
    },
    //选择文件
    uploadFile(file, fileList, ref, item, index) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 1);
      api.uploadFile(formData)
        .then((res) => {
          fileList[index] = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpFile: res.httpFile,
          }
          this.$forceUpdate()
          this.$refs[ref][0].clearFiles();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addImage(arr) {
      console.log(arr);
      arr.push({ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] });
      this.$forceUpdate()
    },
    removeImage(arr, index) {
      if (arr[index].id) {
        this.del_atta_list.push(arr[index].id);
      }
      console.log(this.del_atta_list);
      arr = arr.splice(index, 1);
      this.$forceUpdate()
    },
    addReceive(arr) {
      arr.push({
        id: '',
        receive_amount: '',
        receive_date: '',
        atta_str: [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
      });
    },
    removeReceive(arr, index) {
      if (!arr[index].id) {
        this.del_receive_list.push(arr[index].id);
        arr = arr.splice(index, 1);
      }
    },
    projectChange(v) {
      this.form.project_bill_id = ''
      this.billList = []
      this.toReceive = ''
      this.form.tax_rate = ''
      if (v) {
        this.$fly
          .post('apiProject_getDetail.html', { project_id: v })
          .then((res) => {
            this.billList = res.billList
            this.projectArr = res.itemArr
            this.query.bid && (this.form.project_bill_id = this.query.bid) && this.billChange(this.query.bid)//带参数
          })
      }
    },
    billChange(v) {
      this.toReceive = ''
      this.form.tax = ''
      const {
        client_company,
        company_id_card,
        reg_address,
        company_phone,
        pay_bank,
        pay_bank_account,
        tax,
        tax_rate,
      } = this.projectArr
      this.form = {
        ...this.form,
        client_company,
        company_id_card,
        reg_address,
        company_phone,
        pay_bank,
        pay_bank_account,
        tax,
        tax_rate,
      }
      this.billList.forEach(item => {
        if (item.id == v) {
          this.billArr = item
          this.form.amount = item.amount
        }
      })
      if (this.billArr.amount) {//如果先填了金额，自动修改税额
        this.amountChange()
      }
    },
    amountChange() {
      const taxRate = Number(this.projectArr.tax_rate);
      this.form.tax = (this.billArr.amount) > 0 ? (this.billArr.amount / ((100 + taxRate) / 100) * taxRate / 100).toFixed(2) : 0
    },
    async getDetail(id) {
      this.checkUrlFn()
      this.checkNodeFn('61')
      this.$fly
        .post('apiSale_getInvoiceApplyDetail.html', {
          apply_id: id,
        })
        .then((res) => {
          const atta_str = () => [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
          let form = res.itemArr
          //修改0000-00-00错误显示1899年情况       
          form.receiveList = form.receiveList.map((item) => {
            item.receive_date = timeFormat(item.receive_date)
            item.atta_str = item.fileList.length != 0 ? item.fileList : atta_str()
            return item
          })
          form.invoiceList = form.invoiceList.map((item) => {
            item.invoice_date = timeFormat(item.invoice_date)
            item.atta_str = item.fileList.length != 0 ? item.fileList : atta_str()
            return item
          })
          //防空情况
          if (res.itemArr.receiveList.length === 0) {
            form.receiveList = [{ receive_amount: '', receive_date: '', atta_str: atta_str() }]
          }
          if (res.itemArr.invoiceList.length === 0) {
            form.invoiceList = [{ invoice_no: '', invoice_code: '', invoice_amount: '', invoice_date: '', status: '', atta_str: atta_str() }]
          }
          setTimeout(() => {
            //权限
            this.level = store.state.level
            this.realName = store.state.realName
          }, 200);
          return (this.form = form)
        })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdateInvoiceApply()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addUpdateInvoiceApply() {
      this.form.apply_id = this.query.id || ''
      this.form.option = this.form.id ? '2' : '1'
      // 替换掉id为receive_id
      const $receiveList = this.form.receiveList.map((item) => {
        Object.keys(item).forEach(key => {
          if (key == 'id') {
            item['receive_id'] = item[key]
            delete item[key]
          }
        })
        // 替换掉id为file_id
        item.atta_str = item.atta_str.map((it) => {
          delete it.flist
          delete it.httpFile
          delete it.create_time
          Object.keys(it).forEach(_key => {
            if (_key == 'id') {
              it['file_id'] = it[_key] || 0
              delete it[_key]
            }
          })
          return it
        })
        delete item.create_time
        delete item.cancel_time
        return item
      })
      this.form.receiveList = $receiveList
      const tempForm = JSON.parse(JSON.stringify(this.form))
      delete tempForm.projectArr
      delete tempForm.billArr
      delete tempForm.receiveList
      delete tempForm.invoiceList
      delete tempForm.applyLogList
      delete tempForm.hope_time
      if (!this.query.id) {
        tempForm.apply_status = '1'
      }
      this.$fly
        .post('apiSale_addUpdateInvoiceApply.html', {
          ...tempForm,
          receive_str: JSON.stringify(this.form.receiveList),
          receive_del: this.del_receive_list.toString(),
          receive_atta_del: this.del_atta_list.toString(),
        })
        .then((res) => {
          console.log(res)
          if (res.status === 200) {
            this.$message.success(res.message)
          }
          this.$router.go(-1)
        })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },
    clickCopy(msg) {
      const save = function (e) {
        e.clipboardData.setData('text/plain', msg.replace(/\s*/g, ""))
        e.preventDefault() // 阻止默认行为
      }
      const once = {
        once: true
      }
      document.addEventListener('copy', save, once) // 添加一个copy事件,当触发时执行一次,执行完删除
      document.execCommand('copy') // 执行copy方法
      this.$message({ message: '复制成功', type: 'success' })
    },
  },
}
</script>

<style lang="scss" scoped>
.materialwrap {
  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;

    .anlist {
      padding: 0;

      li {
        position: relative;

        .abox {
          .abox-title {
            font-size: 13px;
            line-height: 32px;
            margin-bottom: 30px;
          }
        }

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    ul {
      @extend %start;
      color: #231f20;
      background: #f2f2f2;
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }



          .bbox {
            width: 100%;
            padding: 0;
            display: block;

            li {
              width: 100%;
              height: 42px;

              &:last-child {
                width: 100%;
                padding-left: 0;
              }
            }
          }
        }
      }
    }
  }
}</style>
